<template>
  <div>
    <el-dialog
     top="20vh"
     lock-scroll
     :show-close="false"
    :visible.sync="$store.state.dialogShowIf"
     @closed=closed>
    <el-form label-position="left" :inline="true" label-width="100px" :model="formData" ref="refFormData">
      <el-form-item
       label="称呼"
       prop="name"
       :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]" >
        <el-input
        size="medium"
        placeholder="请输入名称"
        v-model="formData.name">
        </el-input>
        <label slot="label" class="formLable">称&nbsp;&nbsp;呼</label>
      </el-form-item>
      <el-form-item
       label="联系方式"
       prop="information"
       :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }]">
        <el-input
        placeholder="请输入联系方式"
        v-model="formData.information">
        </el-input>
        <label slot="label" class="formLable">联系方式</label>
      </el-form-item>
      <el-form-item
      prop="service_content"
      label="服务内容"
      :rules="[{ required: true, message: '请输入服务内容', trigger: 'blur' }]">
        <el-input
        placeholder="请输入服务内容"
        v-model="formData.service_content">
        </el-input>
        <label slot="label" class="formLable">服务内容</label>
      </el-form-item>
    </el-form>
    <el-form label-position="top" :model="formData" :inline="false">
      <el-form-item label="需求描述" prop="requirement">
        <el-input placeholder="请输入需求描述" type="textarea" :rows="10" v-model="formData.requirement"></el-input>
        <label slot="label" class="formLable">需求描述</label>
      </el-form-item>
      <el-form-item class="elbtn">
        <el-button type="primary" @click="submitForm('refFormData')">立即提交</el-button>
      </el-form-item>
    </el-form>

    </el-dialog>
  </div>
</template>
<script>
import { putguest } from 'api/index'
export default {
  name: 'adm_contact',
  data () {
    return {
      formData: {
        name: '',
        information: '',
        service_content: '',
        requirement: '',
        type:1,
      }
    }
  },
  props: {
    // dialogShowIf: {
    //   typeof: Boolean,
    //   default: false
    // }
  },
  computed: {},
  watch: {},
  mounted () {},
  methods: {
    closed () {
      this.$store.commit('SET_DIALOGSHOWIF', false)
      this.$refs.refFormData.resetFields()
    },
    submitForm (formName) {
      // console.log(this.publishForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.formData)
          putguest(this.formData).then((res) => {
            // console.log(res)
            // this.$refs[formName].resetFields()
            this.closed()
            this.formData.requirement = ''
          })
        } else {
          return false
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import './index.scss'
</style>
